import React, {Component} from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import DropDownIcon from '../../assets/CustomDropDownIcon';
import CheckBox from '../checkbox';
import './index.css';
import Translate from '../Translate';
import TranslateProperty from "../TranslateProperty";

const styles = {
    wrapper: {
        width: '100%',
        position: 'relative',
    },
    titleClosed: {
        height: '100%',
        padding: '15px',
        color: '#fff',
        border: 'none',
        display: 'flex',
        fontSize: '16px',
        backgroundColor: 'rgb(4, 62, 92)',
        borderRadius: '10px',
        WebkitBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        MozBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        boxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
    },
    titleOpened: {
        height: '50px',
        padding: '15px',
        color: '#fff',
        border: 'none',
        display: 'flex',
        fontSize: '16px',
        backgroundColor: '#3D568F',
        borderRadius: '10px',
    },
    optionsWrapper: {
        maxHeight: '300px',
        overflow: 'auto',
        margin: 'unset',
        padding: 'unset',
        paddingTop: '5px',
        listStyleType: 'none',
        position: 'absolute',
        backgroundColor: '#F2F5FB',
        width: '100%',
        WebkitBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        MozBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        boxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
        zIndex: 9999,
    },
    unselectedOption: {
        padding: '15px',
        color: '#09183A',
        cursor: 'pointer',
        display: 'flex',
    },
    selectedOption: {
        padding: '15px',
        color: '#09183A',
        cursor: 'pointer',
        display: 'flex',
        backgroundColor: '#DDE4F6',
    },
    searchInput: {
        padding: '10px',
        width: 'calc(100% - 20px)',
        margin: '10px',
        boxSizing: 'border-box',
        borderRadius: '5px',
        border: '1px solid #ccc',
    },
    actionItem: {
        ...this.unselectedOption,
        fontWeight: 'bold',
        borderBottom: '1px solid #ccc',
    },
};

class MultiSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listOpen: false,
            searchText: '',
        };
    }

    handleClickOutside = () => {
        this.close();
    };

    close = () => {
        this.setState({
            listOpen: false,
            searchText: '',
        });
    };

    toggleList = () => {
        this.setState(prevState => ({
            listOpen: !prevState.listOpen,
            searchText: '',
        }));
    };

    handleItemSelect = id => checked => {
        const {selectedIds, handleSelect} = this.props;
        if (checked) {
            handleSelect([...selectedIds, id]);
        } else {
            handleSelect(selectedIds.filter(curId => curId !== id));
        }
    };

    handleSelectAll = ids => {
        this.props.handleSelect(ids);
    };

    render() {
        const {listOpen, searchText} = this.state;
        const {selectedIds, options, titleKey} = this.props;

        const nonSelectableColumn = ['user', 'subject', 'description'];

        const filteredOptions = options.filter(option =>
            option.title.toLowerCase().includes(searchText.toLowerCase())
        );

        const allFilteredIds = filteredOptions.map(option => option.id);

        const allSelected =
            allFilteredIds.length > 0 &&
            allFilteredIds.every(id => selectedIds.includes(id));

        return (
            <div style={styles.wrapper}>
                <div
                    style={listOpen ? styles.titleOpened : styles.titleClosed}
                    onClick={this.toggleList}
                >
                    <div
                        style={{
                            flexGrow: 1,
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                        }}
                    >
                        <Translate text={titleKey} />{' '}
                        {!nonSelectableColumn.includes(titleKey)
                            ? `(${selectedIds.filter((s) => s !== -1).length})`
                            : ''}
                    </div>
                    {!nonSelectableColumn.includes(titleKey) && (
                        <DropDownIcon
                            isOpened={listOpen}
                            width="20px"
                            height="20px"
                            fill="#fff"
                        />
                    )}
                </div>

                {listOpen && !nonSelectableColumn.includes(titleKey) && (
                    <ul style={styles.optionsWrapper} onClick={e => e.stopPropagation()}>
                        <li>
                            <TranslateProperty properties={[{key: 'placeholder', value: 'search'}]}>
                                <input
                                    type="text"
                                    style={styles.searchInput}
                                    value={searchText}
                                    onChange={e => this.setState({searchText: e.target.value})}
                                />
                            </TranslateProperty>
                        </li>

                        {filteredOptions.length > 0 && (
                            <React.Fragment>
                                <li
                                    style={styles.unselectedOption}
                                    onClick={() =>
                                        this.handleSelectAll(
                                            allSelected
                                                ? selectedIds.filter(id => !allFilteredIds.includes(id))
                                                : [...new Set([...selectedIds, ...allFilteredIds])]
                                        )
                                    }
                                >
                                    <Translate
                                        text={allSelected ? 'unselectAll' : 'selectAll'}
                                    />
                                </li>
                            </React.Fragment>
                        )}

                        {filteredOptions.map(option => (
                            <li
                                className="listItem"
                                key={option.id}
                                style={
                                    selectedIds.includes(option.id)
                                        ? styles.selectedOption
                                        : styles.unselectedOption
                                }
                            >
                                <CheckBox
                                    checked={selectedIds.includes(option.id)}
                                    handleChange={this.handleItemSelect(option.id)}
                                    text={option.title}
                                />
                                <span style={{marginLeft: '5px'}}>
                                    {option.title}
                                </span>
                            </li>
                        ))}

                        {filteredOptions.length === 0 && (
                            <li style={{padding: '15px', color: '#999'}}>
                                <Translate text="No results found"/>
                            </li>
                        )}
                    </ul>
                )}
            </div>
        );
    }
}

MultiSelect.propTypes = {
    options: PropTypes.array,
    titleKey: PropTypes.string,
    handleSelect: PropTypes.func,
    selectedIds: PropTypes.array,
};

MultiSelect.defaultProps = {
    options: [{id: 0, title: 'No Options to Select'}],
    titleKey: 'Multi Select',
    selectedIds: [],
};

export default onClickOutside(MultiSelect);



// WEBPACK FOOTER //
// ./src/components/multi-select/index.jsx